<template>
    <nav aria-label="pagination" v-if="listPagination !== null">
        <ul class="pagination justify-content-center">
            <template v-if="listPagination.pages < 7">
                <template v-for="item in listPagination.pages">
                    <li class="page-item" :class="item === listPagination.page ? 'active' : ''" @click="listPagination.page !== item ? setPage(item) : null"><a class="page-link">{{ item }}</a></li>
                </template>
            </template>
            <template v-else="">
                <li class="page-item" :class="listPagination.page === 1 ? 'active' : ''" @click="listPagination.page !== 1 ? setPage(1) : null"><a class="page-link">1</a></li>

                <li class="page-item disabled" v-if="listPagination.page > 3"><a class="page-link" href="#">...</a></li>

                <li class="page-item" v-if="listPagination.page > 2" @click="setPage(listPagination.page - 1)"><a class="page-link">{{ listPagination.page - 1 }}</a></li>
                <li class="page-item active" v-if="listPagination.page > 1 && listPagination.page < listPagination.pages"><a class="page-link">{{ listPagination.page }}</a></li>
                <li class="page-item" v-if="listPagination.page < (listPagination.pages - 1)"  @click="setPage(listPagination.page + 1)"><a class="page-link">{{ listPagination.page + 1 }}</a></li>

                <li class="page-item disabled" v-if="listPagination.page < (listPagination.pages - 2)"><a class="page-link" href="#">...</a></li>

                <li class="page-item" :class="listPagination.page === listPagination.pages ? 'active' : ''" @click="listPagination.page !== listPagination.pages ? setPage(listPagination.pages) : null"><a class="page-link">{{ listPagination.pages }}</a></li>
            </template>
        </ul>
    </nav>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    props: {
      listPagination: {
        type: Object,
        required: true
      }
    },
    methods: {
      setPage (page) {
        this.$emit('set-page', page)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PaginationComponent.vue?4986f0bd